import React from 'react';

import { isDesktop } from '../../utils';

export default class ReadMore extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      maxHeight: 99,
      needExpand: false,
      isExpanded: false,
    };
  }

  onMouseOverHandler() {
    if (!this.state.needExpand) {
      return;
    }
    this.setState({ isExpanded: true });
  }

  onMouseLeaveHandler() {
    if (!this.state.needExpand) {
      return;
    }
    this.setState({ isExpanded: false });
  }

  componentDidMount() {
    if (!this.refs.textContainer) {
      return;
    }

    setTimeout(() => {
      const clientHeight = this.refs.textContainer.clientHeight;
      const needExpand = clientHeight > this.state.maxHeight;
      this.setState({ needExpand });
    }, 0);
  }

  getClasses() {
    const { needExpand, isExpanded } = this.state;
    const isHidden = !needExpand || (needExpand && isExpanded);
    const { isFull, isSingle, gridWrap } = this.props;

    return {
      full: isFull,
      'not-full': !isFull,
      'width-bigger': (!isFull && isSingle && !gridWrap) && isDesktop(),
      'width-444': ((!isFull && !isSingle) || gridWrap) && isDesktop(),
      enabled: needExpand,
      expanded: isExpanded,
      hidden: isHidden,
    };
  }
}



// WEBPACK FOOTER //
// ./src/components/storefront/components/Comment/ReadMore.js